import { Link } from "react-router-dom";
import {
  formatViews,
  getPopularMovies,
  getTopicMovies,
} from "@/lib/catalog";

const TAGS = [
  "年轻的母亲",
  "亲情",
  "治愈",
  "悬疑",
  "家庭",
  "都市",
  "催泪",
  "古装",
  "科幻",
  "美食",
];

export default function HomeSidebar() {
  const topicMovies = getTopicMovies().slice(0, 5);
  const ranking = getPopularMovies(5);

  return (
    <aside className="flex flex-col gap-6">
      {/* 专题推荐 */}
      <section className="rounded-lg bg-primary-50 border border-primary-100 overflow-hidden">
        <div className="px-4 py-3.5 border-b border-primary-100 flex items-center justify-between">
          <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-heart-3-line text-xs"></i>
            </span>
            专题 · 年轻的母亲
          </h2>
          <Link
            to="/category/topic"
            className="text-xs text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            全部
          </Link>
        </div>
        <ul className="p-3 space-y-2">
          {topicMovies.map((movie, i) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 p-1.5 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
              >
                <span className="w-6 text-center font-heading font-bold text-sm text-primary-500">
                  {i + 1}
                </span>
                <span className="w-10 h-14 rounded overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={movie.cover}
                    alt={`${movie.title} 海报`}
                    title={`${movie.title} - 主题专题`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {movie.title}
                  </span>
                  <span className="block mt-0.5 text-[11px] text-foreground-500">
                    {movie.year} · {movie.genres.join("/")}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {/* 排行榜 */}
      <section className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
        <div className="px-4 py-3.5 border-b border-background-200">
          <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
              <i className="ri-bar-chart-2-line text-xs"></i>
            </span>
            热门点击榜
          </h2>
        </div>
        <ul className="p-3 space-y-1">
          {ranking.map((movie, i) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
              >
                <span
                  className={`w-6 h-6 rounded flex items-center justify-center text-xs font-bold shrink-0 ${
                    i < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="min-w-0 flex-1 text-sm text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {movie.title}
                </span>
                <span className="text-[11px] text-foreground-400 whitespace-nowrap flex items-center gap-0.5">
                  <i className="ri-eye-line"></i>
                  {formatViews(movie.views)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {/* 网站简介 */}
      <section className="rounded-lg bg-secondary-50 border border-secondary-100 p-4">
        <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
          <span className="w-6 h-6 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
            <i className="ri-information-line text-xs"></i>
          </span>
          关于本站
        </h2>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
          年轻的母亲在线专注“年轻的母亲”主题影视内容，同时提供丰富的电影与电视剧资源，帮助你快速查找、筛选并了解剧情介绍。
        </p>
        <Link
          to="/about"
          className="mt-3 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer"
        >
          了解更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </section>

      {/* 热门标签 */}
      <section className="rounded-lg bg-background-100 border border-background-200 p-4">
        <h2 className="font-heading font-bold text-base text-foreground-950 mb-3">
          热门标签
        </h2>
        <div className="flex flex-wrap gap-2">
          {TAGS.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="px-2.5 py-1 text-xs rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
            >
              {tag}
            </Link>
          ))}
        </div>
      </section>
    </aside>
  );
}